const bot = {
  Bot: {
    group: 'نام گروه',
    token: 'توکن',
    Generate_token: 'ساخت توکن جدید',
    Generate_token_alarm: 'با تغییر توکن ارسال اعلانات به کاربران متوقف میشود٬ آیا از ساخت توکن جدید اطمینان دارید؟',
    fetch_steps: 'به روزرسانی اعلانات',
  },
}

export default bot
